import { VariableType } from 'json-to-graphql-query';
export const GroupVariables = {
    name: 'String!',
    auto: 'Boolean!',
    data: 'GroupDataInput'
};
export const GroupArgs = {
    group: {
        name: new VariableType('name'),
        auto: new VariableType('auto'),
        data: new VariableType('data')
    }
};
export const UpdateGroupVariables = {
    ...GroupVariables,
    id: 'Int!'
};
export const UpdateGroupArgs = {
    ...GroupArgs,
    id: new VariableType('id')
};
//# sourceMappingURL=group.js.map